import { BulkOneClickPrintOrderLimit } from "@redotech/redo-fulfillment-common/bulk-shipment-print";
import * as z from "zod";
import { BulkOneClickPrintBatchesSchema } from "./get-bulk-one-click-print-summary";

export const getBulkOneClickPrintFulfillmentGroupIds = {
  name: "getBulkOneClickPrintFulfillmentGroupIds" as const,
  input: z.object({ batches: BulkOneClickPrintBatchesSchema }),
  output: z.object({
    fulfillmentGroupIds: z.array(z.string()).max(BulkOneClickPrintOrderLimit),
    requiresLabelPurchase: z.boolean(),
    someLabelsPrinted: z.boolean(),
    itemCount: z.number().nonnegative(),
    packingSlipIds: z.array(z.string()).max(BulkOneClickPrintOrderLimit),
    personalizedSlipIds: z.array(z.string()).max(BulkOneClickPrintOrderLimit),
  }),
};
